import React, { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { Dispatch } from 'redux'

import ProjectBox from './components/ProjectBox'
import { updatePageTitle } from '../../redux/active_page/actions'

const ProjectsPage = () => {

	const dispatch: Dispatch = useDispatch()
	useEffect(() => {
		dispatch(updatePageTitle("Projects"));
	}, [])

	return (
		<div className="vertical-flow center p-center">
			<div className="projects-section">
				<h1>My Projects</h1>
				<div className="box-container">
					{/* <!-- <div className="project-box">
						<img src="../img/projects/clean.png" alt="" />
						<div className="project-content">
							<h3 className="no-select">Cleaning Company</h3>
							<p className="no-select">Wordpress Website</p>
							<a href="https://dev-clean-house.pantheonsite.io/" target="_blank" className="btn-project btn">View Project</a>
						</div>
					</div> --> */}

					{/* TODO: // ADD required Props */}
					<ProjectBox></ProjectBox>

					<div className="project-box">
						<img src="../img/projects/interior.png" alt="" />
						<div className="project-content">
							<h3 className="no-select">Interior Design</h3>
							<p className="no-select">Wordpress Website</p>
							<a href="https://dev-al-isra-interiors.pantheonsite.io/" target="_blank" className="btn-project btn">View Project</a>
						</div>
					</div>

					<div className="project-box">
						<img src="../img/projects/madrissa.png" alt="" />
						<div className="project-content">
							<h3 className="no-select">Madrissa School</h3>
							<p className="no-select">Core Frontend Website</p>
							<a href="https://jamadrissa.netlify.app/index.html" target="_blank" className="btn-project btn">View Project</a>
						</div>
					</div>

					<div className="project-box">
						<img src="../img/projects/saloon.png" alt="" />
						<div className="project-content">
							<h3 className="no-select">Saloon Shop</h3>
							<p className="no-select">Core Frontend Website</p>
							<a href="https://saloonapp.netlify.app/" target="_blank" className="btn-project btn">View Project</a>
						</div>
					</div>

					<div className="project-box">
						<img src="../img/projects/tictactoe.png" alt="" />
						<div className="project-content">
							<h3 className="no-select">Tictactoe Console App</h3>
							<p className="no-select">Core Java App</p>
							<a href="https://www.youtube.com/watch?v=VKHwobvmYAY" target="_blank" className="btn-project btn">View Project</a>
						</div>
					</div>

					<div className="project-box">
						<img src="../img/projects/weather.png" alt="" />
						<div className="project-content">
							<h3 className="no-select">Weather App</h3>
							<p className="no-select">Spring Boot Project</p>
							<a href="https://open-weather-map-weather.herokuapp.com/" target="_blank" className="btn-project btn">View Project</a>
						</div>
					</div>

				</div>
			</div>
		</div>
	)
}

export default ProjectsPage